import React from "react";

import Slider from "react-slick";

const Testimonials = ({ classicHeader, darkTheme }) => {
  const reviews = [
    {
      name: "Nun Sophanon",
      position: "Odoo Project Leader of ERPCambodia",
      src: "images/testimonial/non.jpg",
      desc: "I highly admire my coworker Kimteng for their exceptional work in software development. Their technical skills, strong sense of responsibility, and ability to deliver high-quality results make them stand out. I am proud to have worked with Kimteng and confident in their continued success.",
      rating: 5,
    },
    {
      name: "Dinesh Kumar",
      position: "Senior Lecturer at Kirirom Institute of Technology",
      src: "images/testimonial/dinesh.jpg",
      desc: "Kimteng is a standout full-stack developer with exceptional technical skills and a strong sense of responsibility. I'm impressed by Kimteng's ability to work efficiently and effectively, delivering high-quality results on every project. I'm proud to have taught Kimteng and confident in their continued success in software development.",
      rating: 5,
    },
    // {
    //   name: "Leo Fernandez",
    //   position: "Vice President of Academic Affairs, Kirirom Institute of Technology",
    //   src: "images/testimonial/leo_fernandez.jpg",
    //   desc: "I have had the pleasure of teaching Kimteng, who has impressed me with their full-stack development skills and strong sense of responsibility. I have seen first-hand how they deliver high-quality results efficiently, and I am impressed by their focus and dedication. I am proud of Kimteng's achievements and I believe that they have a bright future ahead in software development.",
    //   rating: 5,
    // },
  ];

  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <section
      id="testimonial"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Testimonial
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Reference
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}

        <Slider {...settings}>
          {reviews.length > 0 &&
            reviews.map((value, index) => (
              <div className="item" key={index}>
                <div
                  className={
                    " rounded p-5 " + (darkTheme ? "bg-dark" : "bg-light")
                  }
                >
                  <div className="d-flex align-items-center mt-auto mb-4">
                    <img
                      className="img-fluid rounded-circle border d-inline-block w-auto"
                      src={value.src}
                      alt=""
                    />
                    <p className="ms-3 mb-0">
                      <strong
                        className={
                          "d-block fw-600 " +
                          (darkTheme ? "text-white" : "text-dark")
                        }
                      >
                        {value.name}
                      </strong>
                      <span className="text-muted fw-500">
                        {" "}
                        {value.position}{" "}
                      </span>
                    </p>
                  </div>
                  <p
                    className={
                      " fw-500 mb-4 " + (darkTheme ? "text-white" : "text-dark")
                    }
                  >
                    “{value.desc}”
                  </p>
                  <span className="text-2">
                    {[...Array(value.rating)].map((value, i) => (
                      <i className="fas fa-star text-warning" key={i} />
                    ))}
                  </span>
                </div>
              </div>
            ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
